





























































































































import { Prop, Component, Vue } from "vue-property-decorator";
import { UIModel } from "../../UIModel";

interface ImportError {
  projectId: string;
  projectNumber: string;
  email: string;
  errors: string[];
}

interface ImportResult {
  successCount: number;
  errors: ImportError[];
  csvData: any[];
}

@Component({})
export default class ProjectUsersImportModal extends Vue {

  @Prop({ required: true }) public model!: UIModel;

  @Prop({ required: true })
  public projectType!: 'ACC' | 'BIM360';

  public show: boolean = false;
  public isLoading: boolean = false;

  public file: File | null = null;

  public previewHeaders: string[] = [];
  public previewRows: any[] = [];
  public users: any[] = [];
  public screenWidth: number = window.innerWidth;
  public importResult: ImportResult | null = null;
  public importErrorMessage = null;
  public uploadKey = 0;
  mounted(): void {
    window.addEventListener("resize", this.onResize);
  }

  beforeDestroy(): void {
    window.removeEventListener("resize", this.onResize);
  }

  public onResize(): void {
    this.screenWidth = window.innerWidth;
  }

  get isMobile(): boolean {
    return this.screenWidth < 768;
  }

  public open(): void {
    this.show = true;
  }

  public close(): void {
    this.show = false;
    this.reset();
  }

  public cancel(): void {
    this.close();
  }

  public async onFileSelected(file: File): Promise<void> {
    if (!file) return;
    try {
      this.reset();
      this.uploadKey++;
      this.file = null;
      const upload = this.$refs.upload as any;
      if (upload?.$refs?.input) {
        upload.$refs.input.value = '';
      }
      this.file = file;

      const text = await file.text();

      const rows = text
        .split("\n")
        .map(r => r.trim())
        .filter(r => r.length > 0)
        .map(r => r.split(","));

      if (!rows.length) return;

      this.previewHeaders = rows[0];

      this.users = rows.slice(1).map(row => {
        const obj: any = {};
        this.previewHeaders.forEach((h, i) => {
          obj[h] = row[i];
        });
        return obj;
      });

      // preview only first 5
      this.previewRows = this.users.slice(0, 5);
      console.log(this.previewHeaders);
      console.log(this.previewRows);

    } catch (err) {
      console.error("CSV parse error:", err);
    }
  }

  public async importProjectUsers(): Promise<void> {

    try {
      this.isLoading = true;
      this.importErrorMessage = null;

      const response = await this.model.importProjectUsersFromFile(this.projectType, { users: this.users });

      this.processImportResult(response);        
    } catch (e) {
      this.importResult = null;
      this.importErrorMessage = e.response?.data || e.message;
    } finally {
      this.isLoading = false;
    }
  }

  private processImportResult(data: any): void {
    if (!data?.results || !Array.isArray(data.results)) {
      this.importResult = {
        successCount: 0,
        errors: [],
        csvData: []
      };
      return;
    }

    let successCount = 0;
    const errors: ImportError[] = [];
    const csvData: any[] = [];

    data.results.forEach((proj: any) => {
      successCount += proj.success || 0;
    });

    this.importResult = {
      successCount,
      errors,
      csvData
    };
  }

  public reset(): void {
    this.file = null;
    this.users = [];
    this.previewHeaders = [];
    this.previewRows = [];
    this.importResult = null;
    this.importErrorMessage = null;
  }

  public downloadTemplate(type: "BIM360" | "ACC"): void {
    let headers: string[] = [];
    let sampleRows: string[][] = [];

    if (type === "ACC") {
      headers = [
        "Action",
        "First Name",
        "Last Name",
        "Company",
        "Email",
        "Project Number",
        "Project Admin (YES/NO)",
        "Docs (YES/NO)",
        "Design Collaboration (YES/NO)",
        "Model Coordination (YES/NO)",
        "Build (YES/NO)",
        "Cost Management (YES/NO)",
        "Takeoff (YES/NO)",
        "Insights (YES/NO)",
        "Default Role / Role 1",
        "Role 2",
        "Role 3",
        "Role 4",
        "Role 5"
      ];

      sampleRows = [
        [
          "Add",
          "Jane",
          "Smith",
          "CompanyNamme",
          "jane.smith@email.com",
          "ACC-1001",
          "NO",
          "YES",
          "YES",
          "YES",
          "YES",
          "NO",
          "NO",
          "YES",
          "Project Admin",
          "Coordinator",
          "Reviewer",
          "Staff",
          "Designer"
        ],
        [
          "Update",
          "Amy",
          "Smith",
          "CompanyNamme",
          "amy.smith@email.com",
          "ACC-1001",
          "NO",
          "YES",
          "YES",
          "YES",
          "YES",
          "NO",
          "NO",
          "YES",
          "Project Admin",
          "Coordinator",
          "",
          "",
          ""
        ]
      ];
    }

    const csvContent =
      headers.join(",") +
      "\n" +
      sampleRows.map(r => r.join(",")).join("\n");

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });

    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");

    link.href = url;
    link.download =
      type === "BIM360"
        ? "bim360-project-user-template.csv"
        : "forma-project-user-template.csv";

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    URL.revokeObjectURL(url);
  }
  
}
